import type { BillingProduct } from '../../services/api/billingService';

export interface OnboardingBundleCatalogEntry {
  product: BillingProduct;
  title: string;
  description: string;
  /** One-time session-style vs recurring platform subscription */
  kind: 'session_or_package' | 'subscription';
  /** Display price for MVP catalog (Stripe Checkout shows authoritative amount). */
  priceLabel: string;
}

/**
 * Commercial catalog aligned with
 * `POST /billing/checkout-session` product keys and
 * `docs/STRIPE_PAYMENT_INTEGRATION_PLAN.md`.
 *
 * Post-MVP bundle keys (`clarity`, `growth`, etc.) remain in `BillingProduct`
 * for API compatibility but are not offered on the default paywall.
 */
export const ONBOARDING_BUNDLE_CATALOG: OnboardingBundleCatalogEntry[] = [
  {
    product: 'foundation_session',
    kind: 'session_or_package',
    title: 'Foundation Session',
    priceLabel: '$2,500',
    description:
      '90-min facilitated session. Full 6-domain company model built. Primary constraint named. Improvement roadmap visible. One-time.',
  },
  {
    product: 'bridge_session',
    kind: 'session_or_package',
    title: 'Bridge Session',
    priceLabel: '$2,500',
    description:
      '90-min facilitated session. Scoped structural transition with waypoints and execution plan. One-time per bridge.',
  },
  {
    product: 'foundation_package',
    kind: 'session_or_package',
    title: 'Foundation Package',
    priceLabel: '$10,000',
    description:
      'Five Foundation/Bridge sessions bundled for clients who want a full domain build upfront.',
  },
  {
    product: 'krysalis_core',
    kind: 'subscription',
    title: 'Krysalis Core',
    priceLabel: '$1,000 / month',
    description:
      'Platform + KRYBOT agent stack. Unlimited agent sessions, weekly model update, daily briefing, entropy tracking.',
  },
  {
    product: 'co_development_early_adopter',
    kind: 'subscription',
    title: 'Co-development Early Adopter',
    priceLabel: '$5,000 / month · 5 months',
    description:
      'Co-development Early Adopter commitment: $5,000 per month for a fixed 5-month period ($25,000 total). Subscription auto-ends after five months.',
  },
];
